"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __param = (this && this.__param) || function (paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
};
var _a, _b, _c, _d;
Object.defineProperty(exports, "__esModule", { value: true });
exports.ChatSettingsComponent = void 0;
const T = __importStar(require("@microsoft/fast-element"));
const fast_element_1 = require("@microsoft/fast-element");
require("./template.html");
const client_1 = require("@rws-framework/client");
const component_1 = require("@front/components/form-parts/form/component");
const voices_helper_1 = require("@front/helpers/voices.helper");
const component_2 = require("@front/layouts/default-layout/component");
const chatSettings_types_1 = require("@front/types/chatSettings.types");
const StorageService_1 = __importStar(require("@front/services/StorageService"));
const SignalService_1 = __importStar(require("@front/services/SignalService"));
const client_2 = __importStar(require("@rws-framework/client"));
//@ts-ignore                
let rwsTemplate = T.html `<div class="container-fluid">
  <div class="chat-settings-form-page">    
    <div class="card card-body mb-5">
      <the-form :onSubmit="${(x, c) => x.handleSubmit.bind(x)}">
        <div class="form-row">
          <div class="form-group col-md-12">
            <h3>${'chat.settings.media_generation'.t()}</h3>
          </div>
          <div class="form-group col-md-6">
            <part-select class="form-part" label="${'chat.settings.image_model'.t()}" :value="${x => x.form.imageModel}"
              name="imageModel" :options="${x => x.imageModelOptions}"></part-select>
          </div>
        </div>
        <div class="form-row">
          <div class="form-group col-md-12">
            <part-select class="form-part" label="${'chat.settings.voice.label'.t()}"
              :value="${x => x.form.voice || ''}" name="voice" :options="${x => x.voiceOptions}"
              @change="${(x, c) => x.onVoiceChange(c.detail.value)}"></part-select>
          </div>
        </div>

        <div class="form-row">
          <div class="form-group col-md-12">
            <h3>${'chat.settings.ai_parameters'.t()}</h3>
          </div>
          <div class="form-group col-md-12">
            <part-slider class="form-part" label="${'chat.settings.temperature.label'.t()}"
              minLabel="${'chat.settings.temperature.min_label'.t()}" maxLabel="${'chat.settings.temperature.max_label'.t()}"
              :value="${x => x.form.temperature || 0.7}" name="temperature" 
              min="0" max="1" step="0.1" showValue="true"></part-slider>
            <p>
              <small>${'chat.settings.temperature.description'.t()}</small>
            </p>
          </div>
          <div class="form-group col-md-12">
            <part-select class="form-part" label="${'chat.settings.max_tokens.label'.t()}"
              :value="${x => x.form.maxTokens}" name="maxTokens" :options="${x => x.maxTokensOptions}"></part-select>
            <p>
              <small>${'chat.settings.max_tokens.description'.t()}</small>
            </p>
          </div>
          <div class="form-group col-md-12">
            <part-checkbox class="form-part" label="${'chat.settings.thinking.label'.t()}"
              :value="${x => x.form.thinking || false}" name="thinking"></part-checkbox>
              <p>
                <small>${'chat.settings.thinking.description'.t()}</small>
              </p>
          </div>
        </div>

        <div class="form-row">
          <div class="form-group col-md-12">
            <h3>${'chat.settings.assistance_setup'.t()}</h3>
          </div>
          <div class="form-group col-md-12">
            <part-checkbox class="form-part" label="${'chat.settings.chat_learning.label'.t()}"              
              :value="${x => x.form.chatLearning || false}" name="chatLearning"></part-checkbox>
              <p>
                <small>${'chat.settings.chat_learning.description'.t()}</small>
              </p>
          </div>
          <div class="form-group col-md-12">
            <part-checkbox class="form-part" label="${'chat.settings.extended_context.label'.t()}"
              :value="${x => x.form.extendedContext || false}" name="extendedContext"></part-checkbox>
              <p>
                <small>${'chat.settings.extended_context.description'.t()}</small>
              </p>
          </div>
        </div>

        <div class="form-row">
          <div class="form-group col-md-12">
            ${(0, fast_element_1.when)(x => x.isAIAssistantFeatureEnabled, (0, fast_element_1.html) `
              <part-checkbox class="form-part" label="${'chat.settings.enable_ai_assistant.label'.t()}"
                :value="${x => x.form.enableAIAssistant}" name="enableAIAssistant"></part-checkbox>
            `)}
            ${(0, fast_element_1.when)(x => !x.isAIAssistantFeatureEnabled, (0, fast_element_1.html) `
              <rws-tooltip text="${'chat.settings.enable_ai_assistant.disabled_tooltip'.t()}">
                <part-checkbox class="form-part" label="${'chat.settings.enable_ai_assistant.label'.t()}"
                  :value="${x => x.form.enableAIAssistant}" name="enableAIAssistant" :disabled="${x => true}"></part-checkbox>
              </rws-tooltip>
            `)}
              <p>
                <small>${'chat.settings.enable_ai_assistant.description'.t()}</small>
              </p>
          </div>
        </div>

        <div class="form-row">
          <div class="form-group col-md-12">
            <button type="submit" @click="${(x, c) => x.sendSubmit(x, c)}" class="btn btn-primary">
              ${'chat.settings.save'.t()}
            </button>
            <button type="button" @click="${x => x.handleClose()}" class="btn btn-secondary ml-2">
              ${'common.cancel'.t()}
            </button>
          </div>
        </div>
      </the-form>
    </div>
  </div>
</div>
`;
require("./styles/layout.scss");
const styles = T.css ``;
const shadowOptions = { "mode": "open" };
let ChatSettingsComponent = class ChatSettingsComponent extends client_1.RWSViewComponent {
    constructor(storageService, signalService, apiService) {
        super();
        this.storageService = storageService;
        this.signalService = signalService;
        this.apiService = apiService;
        this.loading = false;
        this.voiceOptions = [];
        this.imageModelOptions = [];
        this.selectedAzureVoice = null;
        this.maxTokensOptions = [];
        this.sendSubmit = component_1.FormComponent.sendSubmitEvent;
    }
    get currentUser() {
        return component_2.DefaultLayout.USER;
    }
    get isAIAssistantFeatureEnabled() {
        var _a, _b, _c;
        return (_c = (_b = (_a = this.currentUser) === null || _a === void 0 ? void 0 : _a.accountGrade) === null || _b === void 0 ? void 0 : _b.promptAssist) !== null && _c !== void 0 ? _c : false;
    }
    async connectedCallback() {
        // Initialize form first
        this.resetForm();
        super.connectedCallback();
        // Load voice and model options
        this.getCurrentVoiceOptions();
        await this.getImageModelsList();
        await this.loadAzureVoices();
        this.initializeMaxTokensOptions();
        // Load saved settings and merge with defaults
        const savedSettings = this.storageService.get('ai.chatSettings');
        if (savedSettings) {
            try {
                const parsedSettings = JSON.parse(savedSettings);
                // Merge with defaults to ensure all properties exist
                this.form = { ...chatSettings_types_1.DEFAULT_CHAT_SETTINGS, ...parsedSettings };
                // Force disable AI Assistant if feature is not available
                if (!this.isAIAssistantFeatureEnabled) {
                    this.form.enableAIAssistant = false;
                    // Save corrected settings back to storage immediately
                    this.storageService.set('ai.chatSettings', JSON.stringify(this.form));
                }
                // Force form update to trigger reactivity
                setTimeout(() => {
                    this.form = { ...this.form };
                }, 10);
            }
            catch (e) {
                console.warn('Failed to parse saved chat settings, using defaults', e);
                this.form = { ...chatSettings_types_1.DEFAULT_CHAT_SETTINGS };
                if (!this.isAIAssistantFeatureEnabled) {
                    this.form.enableAIAssistant = false;
                    // Save corrected settings back to storage immediately
                    this.storageService.set('ai.chatSettings', JSON.stringify(this.form));
                }
            }
        }
        // Only bind form change listeners after everything is properly initialized
        component_1.FormComponent.listenForValuesChange.bind(this)('form');
    }
    resetForm() {
        this.form = { ...chatSettings_types_1.DEFAULT_CHAT_SETTINGS };
        // Force disable AI Assistant if feature is not available
        if (!this.isAIAssistantFeatureEnabled) {
            this.form.enableAIAssistant = false;
            // Save corrected settings back to storage immediately
            this.storageService.set('ai.chatSettings', JSON.stringify(this.form));
        }
    }
    async getImageModelsList() {
        const modelData = await this.apiService.back.get('ai.image_model-list');
        this.imageModelOptions = modelData.data.map((el => ({
            label: el.name,
            value: el.id
        })));
    }
    getCurrentVoiceOptions() {
        // Get Azure voices from helper
        this.voiceOptions = voices_helper_1.AzureVoicesHelper.getVoiceOptionsForSelect();
    }
    /**
     * Load available Azure voices from the API using AzureVoicesHelper
     */
    async loadAzureVoices() {
        try {
            const voices = await voices_helper_1.AzureVoicesHelper.loadAzureVoicesFromAPI(this.apiService);
            // Update voice options after loading
            this.getCurrentVoiceOptions();
            // Set default Azure voice if none selected and form has no voice
            if (!this.form.voice && voices.length > 0) {
                // Try to find an English voice as default
                const defaultVoice = voices_helper_1.AzureVoicesHelper.getDefaultVoiceForLocale('en');
                if (defaultVoice) {
                    this.selectedAzureVoice = defaultVoice;
                    this.form.voice = defaultVoice.name;
                }
            }
        }
        catch (error) {
            console.error('Failed to load Azure voices:', error);
        }
    }
    /**
     * Initialize max tokens select options
     */
    initializeMaxTokensOptions() {
        this.maxTokensOptions = [
            { label: 'chat.settings.max_tokens.default'.t(), value: null },
            { label: 'chat.settings.max_tokens.short'.t(), value: 1 },
            { label: 'chat.settings.max_tokens.medium'.t(), value: 2 },
            { label: 'chat.settings.max_tokens.long'.t(), value: 3 }
        ];
    }
    /**
     * Handle voice selection change
     */
    onVoiceChange(voice) {
        if (!this.form) {
            console.warn('Form not initialized when trying to set voice');
            return;
        }
        this.form.voice = voice;
        // Update selected Azure voice using helper
        this.selectedAzureVoice = voices_helper_1.AzureVoicesHelper.findAzureVoiceByName(voice);
        // Save to storage immediately
        try {
            this.storageService.set('ai.chatSettings', JSON.stringify(this.form));
        }
        catch (error) {
            console.error('Failed to save voice setting:', error);
        }
    }
    async handleSubmit(event) {
        event.preventDefault();
        // Ensure AI Assistant is disabled if feature is not available
        if (!this.isAIAssistantFeatureEnabled) {
            this.form.enableAIAssistant = false;
        }
        this.storageService.set('ai.chatSettings', JSON.stringify(this.form));
        // Signal AI Assist components to refresh their enabled state
        const assistRefreshSignal = this.signalService.getSignal('ai.assist.refresh', { initialValue: null });
        assistRefreshSignal.setValue({ refresh: true });
        this.notifyService.notify('chat.settings.saved'.t());
        this.dispatchEvent(new CustomEvent('chat_settings:submit', {
            detail: this.form,
            bubbles: true,
            composed: true
        }));
        this.handleClose();
    }
    handleClose() {
        this.$emit('rws_modal:force_close');
    }
};
exports.ChatSettingsComponent = ChatSettingsComponent;
__decorate([
    client_1.observable,
    __metadata("design:type", Boolean)
], ChatSettingsComponent.prototype, "loading", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", typeof (_d = typeof chatSettings_types_1.IChatSettings !== "undefined" && chatSettings_types_1.IChatSettings) === "function" ? _d : Object)
], ChatSettingsComponent.prototype, "form", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", Array)
], ChatSettingsComponent.prototype, "voiceOptions", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", Array)
], ChatSettingsComponent.prototype, "imageModelOptions", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", Object)
], ChatSettingsComponent.prototype, "selectedAzureVoice", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", Array)
], ChatSettingsComponent.prototype, "maxTokensOptions", void 0);
exports.ChatSettingsComponent = ChatSettingsComponent = __decorate([
    (0, client_1.RWSView)('chat-settings', null, { template: rwsTemplate, styles, options: { shadowOptions } }),
    __param(0, (0, client_1.RWSInject)(StorageService_1.default)),
    __param(1, (0, client_1.RWSInject)(SignalService_1.default)),
    __param(2, (0, client_1.RWSInject)(client_2.default)),
    __metadata("design:paramtypes", [typeof (_a = typeof StorageService_1.StorageServiceInstance !== "undefined" && StorageService_1.StorageServiceInstance) === "function" ? _a : Object, typeof (_b = typeof SignalService_1.SignalServiceInstance !== "undefined" && SignalService_1.SignalServiceInstance) === "function" ? _b : Object, typeof (_c = typeof client_2.ApiServiceInstance !== "undefined" && client_2.ApiServiceInstance) === "function" ? _c : Object])
], ChatSettingsComponent);
ChatSettingsComponent.defineComponent();
